export default "__VITE_ASSET__DpjhlTTO__"